var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgExplore = function SvgExplore(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 113,
    viewBox: "0 0 116 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    className: "illustration-background-fill",
    d: "M46.5 0C71.0766 0 91 19.6994 91 43.9995C91 68.3006 71.0766 88 46.5 88C21.9234 88 2 68.3006 2 43.9995C2 19.6994 21.9234 0 46.5 0Z",
    fill: "#F6F7F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    className: "illustration-main-fill",
    d: "M30.6429 19.1429H18.8571V7.35714C18.8571 6.05482 17.8011 5 16.5 5C15.1989 5 14.1429 6.05482 14.1429 7.35714V19.1429H2.35714C1.056 19.1429 0 20.1989 0 21.5C0 22.8011 1.056 23.8571 2.35714 23.8571H14.1429V35.6429C14.1429 36.944 15.1989 38 16.5 38C17.8011 38 18.8571 36.944 18.8571 35.6429V23.8571H30.6429C31.944 23.8571 33 22.8011 33 21.5C33 20.1989 31.944 19.1429 30.6429 19.1429Z",
    fill: "#008C73"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    className: "illustration-light-stroke",
    d: "M48.5013 65.7496C48.5013 54.5818 57.5835 45.4996 68.7513 45.4996C79.9158 45.4996 89.0013 54.5818 89.0013 65.7496C89.0013 76.9175 79.9158 85.9996 68.7513 85.9996C57.5835 85.9996 48.5013 76.9175 48.5013 65.7496ZM108.256 100.489L90.0577 82.2905C93.6116 77.7208 95.7513 71.99 95.7513 65.7496C95.7513 50.8389 83.6621 38.7496 68.7513 38.7496C53.8372 38.7496 41.7513 50.8389 41.7513 65.7496C41.7513 80.6604 53.8372 92.7496 68.7513 92.7496C74.9883 92.7496 80.7157 90.6133 85.2821 87.0628L103.483 105.261C104.796 106.574 106.943 106.574 108.256 105.261C109.569 103.948 109.569 101.801 108.256 100.489Z",
    fill: "#B2BBC0"
  })));
};
export default SvgExplore;